import { createTheme } from "@mui/material";

// Identidad de marca Ficanaz: NARANJA como color principal de marca (logo, sidebar
// activo, acentos de título) y AZUL para las acciones (botones, links, seleccionados).
// Los neutros (grises slate) y los semánticos (verde/rojo/amber) NO cambian.
const BRAND = {
  // Naranja = marca
  orange: "#F2651A",
  orangeDark: "#C9500F",
  orangeLight: "#FF8A4C",
  orangeTint: "#FFF1E8",
  // Azul = acción
  blue: "#2563EB",
  blueDark: "#1D4ED8",
  blueLight: "#60A5FF",
  blueTint: "#E8F0FE",
};

const theme = createTheme({
  palette: {
    // primary = AZUL (acción): los botones color="primary" siguen siendo azules.
    primary: {
      main: BRAND.blue,
      dark: BRAND.blueDark,
      light: BRAND.blueLight,
      contrastText: "#ffffff",
    },
    // secondary = NARANJA (marca): acentos de identidad.
    secondary: {
      main: BRAND.orange,
      dark: BRAND.orangeDark,
      light: BRAND.orangeLight,
      contrastText: "#ffffff",
    },
    // Semáforo de stock/estados (sin cambios).
    success: { main: "#10b981" },
    warning: { main: "#f59e0b" },
    error: { main: "#ef4444" },
    background: {
      default: "#ffffff",
    },
  },
  typography: {
    fontFamily: [
      "Poppins",
      "-apple-system",
      "BlinkMacSystemFont",
      "Segoe UI",
      "Roboto",
      "Helvetica Neue",
      "sans-serif",
    ].join(","),
  },
});

// Tokens de marca accesibles en sx: (theme) => theme.brand.orange, etc.
theme.brand = BRAND;

export default theme;
